<template>
  <div
    class="patient-item"
    :class="{
      'high-light-patient': hightLightPatientId === patient.patientId
    }"
    v-if="!patient.placeholder"
    @click="toIndividual()"
  >
    <div class="flex">
      <div class="room-info v-h-center">
        <div>
          <div>Rm</div>
          <div
            v-if="patient.roomNumber"
            class="room-number"
            :style="{
              fontSize: getRoomNumberFontSize()
            }"
          >
            <span>{{ patient.roomNumber }}</span>
            <span v-if="patient.bedNumber">-{{ patient.bedNumber }}</span>
          </div>
        </div>
      </div>
      <div class="patient-info">
        <div class="alias">{{ patient.alias }}</div>
        <div class="warning-text">
          <span
            :class="
              getWarningInfo.warnings.some(w => w.class === 'type7')
                ? 'green-font'
                : patient.isAlert
                ? 'red-font'
                : 'grey-font'
            "
            >{{ getWarningInfo.text }}</span
          >
          <span
            class="grey-font"
            v-if="getWarningInfo.showNextPadName && patient.data.nextPadName"
          >
            - Put on {{ patient.data.nextPadName }}</span
          >
        </div>
      </div>
    </div>

    <div class="patient-icons">
      <!-- Only show red and empty battery icon, and don't show it when pod lost connection -->
      <!-- <div
        class="battery-icon"
        v-if="
          [batteryStatus.red, batteryStatus.empty].includes(
            patient.data.batteryStatus
          ) && patient.data.podStatus !== 'NODATARECEIVED'
        "
      >
        <div
          class="battery-icon-bar"
          :style="{
            background: '#DD808C',
            width: patient.data.batteryStatus === batteryStatus.red ? '10%' : 0
          }"
        ></div>
      </div> -->
      <!-- Only show upgrade icon when isUpgraded is false -->
      <div class="upgrade-icon" v-if="!patient.data.isUpgraded">
        <svg-icon iconClass="upgrade" class="w-15"></svg-icon>
      </div>
      <!-- <img
        v-if="patient.data.rssiStatus !== 'GOOD'"
        src="@/assets/image/NotificationIcons/wifi.png"
        class="low-rssi-icon"
      /> -->
      <div
        v-for="(warning, index) in getWarningInfo.warnings"
        :key="index"
        class="warning-icon"
        :class="warning.class"
      >
        <div v-if="warning.class === 'type7'" class="analysing-dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
        <img
          v-else
          :src="require('@/assets/image/NotificationIcons/' + warning.imgSrc)"
          :class="warning.imgClass"
          :key="Math.random()"
        />
      </div>
      <div v-if="showRedStartTime" class="red-start-time">
        {{ redStartTime }}
      </div>
    </div>
  </div>
  <div class="patient-item" v-else style="height: 71px;"></div>
</template>

<script>
import { actionType, monitorType, batteryStatus } from '@/const.js'
import moment from 'moment'
export default {
  data() {
    return {
      actionType: actionType,
      monitorType: monitorType,
      batteryStatus: batteryStatus,
      hightLightPatientId: null
    }
  },
  props: {
    patient: {
      require: true,
      type: Object
    }
  },
  mounted() {
    this.getHightLightPatient()
  },
  watch: {
    '$route.query'() {
      this.getHightLightPatient()
    }
  },
  computed: {
    getWarningInfo() {
      let warnings = []
      if (this.patient.isAlert) {
        warnings = this.patient.warnings.map(warning => {
          return this.formatWarnings(
            warning.type,
            this.patient.data.padStatusTrigger
          )
        })
      } else {
        warnings = [this.formatStatus(this.patient.statusNumber)]
      }
      return {
        warnings,
        text: warnings.map(warning => warning.text).join(' & '),
        showNextPadName: warnings.some(item => item.showNextPadName)
      }
    },
    redStartTime() {
      let time = this.patient.redStartTime
      if (!time) return null
      let minutes = moment().diff(moment.utc(time), 'minutes')
      if (minutes < this.showTimeGreaterThanMinutes) return [0, 'm']
      if (minutes >= 1440) {
        let day = Math.round(minutes / 1440)
        return day + 'd'
      } else if (minutes >= 60 && minutes < 1440) {
        let hour = Math.round(minutes / 60)
        return hour + 'h'
      } else {
        return minutes + 'm'
      }
    },
    showRedStartTime() {
      if (
        this.redStartTime &&
        this.patient.isAlert &&
        this.patient.warnings &&
        this.$store.state.customization.isTimeDisplayEnabled
      ) {
        return this.patient.warnings.some(item =>
          [
            this.actionType.check_pad,
            this.actionType.check_time_in_pad
          ].includes(item.type)
        )
      }
      return false
    }
  },
  methods: {
    getRoomNumberFontSize() {
      const roomLength = this.patient.roomNumber
        ? this.patient.roomNumber.length
        : 0
      const bedLength = this.patient.bedNumber
        ? this.patient.bedNumber.length
        : 0
      const length = roomLength + bedLength
      if (length <= 6) {
        return '14px'
      } else if (length <= 8) {
        return '12px'
      } else if (length <= 9) {
        return '11px'
      } else if (length <= 10) {
        return '10px'
      } else {
        return '8px'
      }
    },
    getHightLightPatient() {
      if (this.$route.query && this.$route.query.hightLightPatientId) {
        this.hightLightPatientId = this.$route.query.hightLightPatientId
      }
    },
    formatTitle(value) {
      if (!value) return ''
      value = value.toString().toLowerCase()
      return value.replace(/\b\w/g, function(l) {
        return l.toUpperCase()
      })
    },
    formatWarnings(type, padStatusTrigger) {
      let info
      switch (type) {
        case this.actionType.sensor_disconnected:
          info = {
            imgSrc: 'sensor-disconnected.png',
            class: 'type1',
            text: this.formatTitle(this.$t('text.apply_sensor')),
            imgClass: 'w-30 mb-3'
          }
          break
        case this.actionType.pod_unclipped:
          info = {
            imgSrc: 'pod-unclipped.png',
            class: 'type1',
            text: this.formatTitle(this.$t('text.reclip_pod')),
            imgClass: 'w-30 mb-3'
          }
          break
        case this.actionType.check_connection:
          info = {
            imgSrc: 'pod-unclipped.png',
            class: 'type1',
            text: this.formatTitle(
              this.$t('text.loosely_connected_reclip_pod')
            ),
            imgClass: 'w-30 mb-3'
          }
          break
        case this.actionType.no_data_received:
          info = {
            imgSrc: 'simple-lost-connection.png',
            class: 'type1',
            text: this.formatTitle(this.$t('text.lost_connect')),
            imgClass: 'w-30'
          }
          break
        case this.actionType.lowbattery:
          info = {
            imgSrc: 'simple-replace-battery.png',
            class: 'type1',
            text: this.formatTitle(this.$t('text.replace_battery')),
            imgClass: 'w-30'
          }
          break
        case this.actionType.flatbattery:
          info = {
            imgSrc: 'simple-flat-battery.png',
            class: 'type1',
            text: this.formatTitle(this.$t('text.replace_battery')),
            imgClass: 'w-30'
          }
          break
        case this.actionType.check_position:
          info = {
            imgSrc: 'simple-reposition.png',
            class: 'type1',
            text: this.formatTitle(this.$t('text.change_position')),
            imgClass: 'w-30'
          }
          break
        case this.actionType.check_temperature:
          info = {
            imgSrc: 'temperature-red.svg',
            class: 'type1',
            text: this.formatTitle(this.$t('text.check_temperture')),
            simpleImgSrc: 'temperature-red.svg',
            imgClass: 'w-16 h-32'
          }
          break
        case this.actionType.check_fall:
          info = {
            imgSrc: 'attend-fall.png',
            class: 'type1',
            text: this.formatTitle(this.$t('text.attend_fall')),
            imgClass: 'w-32'
          }
          break
        case this.actionType.check_time_in_pad:
          // When padStatus=red, check another property padStatusTrigger
          // if 1 show text “Goal Time Exceed”, if 2 show text "Predicted Time Exceed", if 3 show text "Safe Time Exceed"
          info = {
            imgSrc: 'simple-pad.png',
            class: 'type2',
            // text:
            //   padStatusTrigger === 1
            //     ? this.formatTitle(this.$t('text.goal_time_exceed'))
            //     : padStatusTrigger === 2
            //     ? this.formatTitle(this.$t('text.predicted_time_exceed'))
            //     : padStatusTrigger === 3
            //     ? this.formatTitle(this.$t('text.safe_time_exceed'))
            //     : this.formatTitle(this.$t('text.change_pad')),
            text: this.$t('text.change'),
            showNextPadName: true,
            imgClass: 'w-30 mt-1'
          }
          break
        case this.actionType.check_bin:
          info = {
            imgSrc: 'pad-in-bin.png',
            class: 'type2',
            text: this.$t('text.check_bin'),
            imgClass: 'w-20'
          }
          break
        //actionType check_pad
        default:
          info = {
            imgSrc: 'simple-pad.png',
            class: 'type2',
            text: this.formatTitle(this.$t('text.change')),
            showNextPadName: true,
            imgClass: 'w-30 mt-1'
          }
      }
      return info
    },
    formatStatus(type) {
      let info
      switch (type) {
        case this.monitorType.YELLOW:
          info = {
            imgSrc: 'simple-pad.png',
            class: 'type4',
            text: '',
            imgClass: 'w-30 mt-1'
          }
          break
        case this.monitorType['CLUMPED-GREEN']:
        case this.monitorType['CLUMPED-YELLOW']:
        case this.monitorType.UNSTABLE:
        case this.monitorType.CLUMPED:
        case this.monitorType.WETSURFACE:
        case this.monitorType.GREEN:
          info = {
            imgSrc: 'simple-pad.png',
            class: 'type5',
            text: '',
            imgClass: 'w-30 mt-1'
          }
          break
        case this.monitorType.ANALYSING:
          info = {
            imgSrc: 'simple-pad-gray.png',
            class: 'type7',
            text: this.formatTitle(this.$t('text.analysing')),
            imgClass: 'w-30 mt-1'
          }
          break
        case this.monitorType.PADNOTSELECTED:
          info = {
            imgSrc: 'simple-pad-gray.png',
            class: 'type6',
            text: this.formatTitle(this.$t('text.not_selected')),
            imgClass: 'w-30 mt-1'
          }
          break
        case this.monitorType.PADUNKNOWN:
          info = {
            imgSrc: 'simple-pad-gray.png',
            class: 'type6',
            text: this.formatTitle(this.$t('text.non_smartz_product_in_use')),
            imgClass: 'w-30 mt-1'
          }
          break
        //actionType check_pad
        default:
          info = {
            imgSrc: 'simple-pad.png',
            class: 'type5',
            text: '',
            imgClass: 'w-30 mt-1'
          }
      }
      return info
    },
    async toIndividual() {
      if (!this.$permission('Patients.View')) {
        return false
      }

      const allPatientIds = this.$store.state.patient.patients.map(
        item => item.patientId
      )
      // Sometimes, it is impossible to find the selected patient, which will cause the system to always display the first patient in the individual dashboard.
      // Use this logic to improve this situation
      if (!allPatientIds.includes(this.patient.patientId)) {
        try {
          await this.$store.dispatch('patient/fetchPatients')
        } catch (error) {
          console.error('Failed to fetch patients:', error)
        }
      }

      const patient = this.$store.state.patient.patients.find(
        p => p.patientId === this.patient.patientId
      )

      if (patient) {
        this.$store.commit('patient/SET_SELECTED_PATIENT', patient)
      } else {
        console.warn(
          'The selected patient is not in the list returned by /Board/GetPatient.'
        )
      }
      this.$router.push('/patients/monitor')
    }
  }
}
</script>

<style lang="scss" scoped></style>
